(function()
{
    //Import classes

    var UIPanel = include('WGBH.UIPanel'),
    	Text=include('WGBH.PIXIText'),
    	
		Sprite = include('PIXI.Sprite'),
		Graphics = include('PIXI.Graphics'),
		Button=include("springroll.pixi.Button"),
		Container=include("PIXI.Container"),
		Point=include("PIXI.Point"),
		Texture = include('PIXI.Texture'),
		EventDispatcher=include('springroll.EventDispatcher');
    /**
     * Panel contains all of the visual elements for the title state
     * @class WGBH.TitlePanel
     * @extends PIXI.Container
     */
    var TitlePanel = function()
    {
        UIPanel.call(this);
    };



    //Extend the base panel
    var p = extend(TitlePanel, UIPanel);

	
	
    /**
     * Setup the state, this happens on each state entering
     */
    p.setup = function()
    {		
        
		this.bg=new PIXI.Sprite(images.bg_fishforce_title);
		this.addChild(this.bg);
		
		this.bg.interactive=true;
		this.bg.on(app.click,this.clickbackground);
		
		this.play=new PIXI.Sprite(images.btn_start);
		this.addChild(this.play);
		this.play.position={x:750,y:590};
    };

    /**
     * Un-setup the panel when exiting the state
     */
    p.teardown = function()
    {
    	// remove the children and stop the button events
		this.bg.off(app.click,this.clickbackground);
    	this.removeChildren();
    };

    //Assign to namespace
    namespace('WGBH').TitlePanel = TitlePanel;
}());